import { Component, input } from '@angular/core';

@Component({
  selector: 'app-page-title-bar',
  imports: [],
  templateUrl: './page-title-bar.component.html',
  styleUrl: './page-title-bar.component.sass'
})
export class PageTitleBarComponent {
  pageTitle = input.required<string>();
  // pageTitleTranslateId = input.required<string>();
}
